import React, { useState } from 'react';
import ChooseBrand from './ChooseBrand';

const ChooseBrandDemo = () => {
  const [selectedBrand, setSelectedBrand] = useState(null);

  const handleBrandSelect = (brand) => {
    setSelectedBrand(brand);
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <ChooseBrand onBrandSelect={handleBrandSelect} />

      {selectedBrand && (
        <div
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            background: 'white',
            padding: '1rem',
            borderRadius: '10px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            zIndex: 1000,
          }}
        >
          <h3>Selected Brand: {selectedBrand.name}</h3>
          <p>Model: {selectedBrand.carModel}</p>
          <p>Description: {selectedBrand.description}</p>
        </div>
      )}
    </div>
  );
};

export default ChooseBrandDemo;
